var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-menu',{attrs:{"transition":"fab-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"dark":"","color":"primary"}},'v-btn',attrs,false),on),[_vm._v(" Fab Transition ")])]}}])},[_c('v-list',_vm._l((5),function(n){return _c('v-list-item',{key:n},[_c('v-list-item-title',{domProps:{"textContent":_vm._s('Item ' + n)}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }